import { lazy, Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

const TariffLookupApp = lazy(() => import('~/apps/smartsend/components/customs/TariffLookupApp'));

export default function Component() {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  useEffect(() => {
    const title = t('TARIFF_LOOKUP_APP_TITLE', { defaultValue: 'Tariff Lookup App' });
    document.title = title;
  }, [t]);

  return (
    <Suspense>
      <TariffLookupApp />
    </Suspense>
  );
}

Component.displayName = 'Tariff Lookup App';
